import "./Table.css"
import KPIs from "./KPI";
import happy from "../images/happy.png"
import { useTranslation } from "react-i18next";
import orderNr from "../images/orderNr.png";
import width from "../images/width.png";
import color from "../images/color.png";
import dueDate from "../images/dueDate.png";
import endTime from "../images/endTime.png";
import sigma from "../images/sigma.png";
import setupTime from "../images/setupTime.png";
import * as dateMath from 'date-arithmetic'

const ordersExample = [
    {
      isOnTime: <img src={happy} width={25} height={25} alt="yes"/>,
      orderNr: 1000,
      width: 10,
      color: <mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>Blau</mark>,
      moveUp: "",
      dueDate: dateMath.add(new Date(), 1, "day").toLocaleDateString(),
      endTime: `${new Date().toLocaleDateString()} 8:00`,
      totalSetupDur: "0:00",
      colorSetupDur: "-",
      widthSetupDur: "0:00",
      score: 0,
      dueDateViolations: 0,
      setupDur: 0
    },
    {
        isOnTime: <img src={happy} width={25} height={25} alt="yes"/>,
        orderNr: 1009,
        width: 25,
        color: <mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>Blau</mark>,
        moveUp: "",
        dueDate: dateMath.add(new Date(), 2, "day").toLocaleDateString(),
        endTime: `${new Date().toLocaleDateString()} 18:30`,
        totalSetupDur: "2:30",
        colorSetupDur: "-",
        widthSetupDur: "2:30",
        dueDateViolations: 0
    },
    {
        isOnTime: <img src={happy} width={25} height={25} alt="yes"/>,
        orderNr: 1004,
        width: 26,
        color: <mark style={{color: "green", backgroundColor: "transparent", fontWeight: 800}}>Grün</mark>,
        moveUp: "",
        dueDate: dateMath.add(new Date(), 1, "day").toLocaleDateString(),
        endTime: `${dateMath.add(new Date(), 1, "day").toLocaleDateString()} 2:40`,
        totalSetupDur: "0:10",
        colorSetupDur: "-",
        widthSetupDur: "0:10",
        dueDateViolations: 0
      },
      {
        isOnTime: <img src={happy} width={25} height={25} alt="yes"/>,
        orderNr: 1005,
        width: 30,
        color: <mark style={{color: "#9C33FF", backgroundColor: "transparent", fontWeight: 800}}>Violett</mark>,
        moveUp: "",
        dueDate: dateMath.add(new Date(), 2, "day").toLocaleDateString(),
        endTime: `${dateMath.add(new Date(), 1, "day").toLocaleDateString()} 11:20`,
        totalSetupDur: "0:40",
        colorSetupDur: "-",
        widthSetupDur: "0:40",
        dueDateViolations: 0
      },
      {
        isOnTime: <img src={happy} width={25} height={25} alt="yes"/>,
        orderNr: 1008,
        width: 21,
        color: <mark style={{color: "#9C33FF", backgroundColor: "transparent", fontWeight: 800}}>Violett</mark>,
        moveUp: "",
        dueDate: dateMath.add(new Date(), 1, "day").toLocaleDateString(),
        endTime: `${dateMath.add(new Date(), 1, "day").toLocaleDateString()} 20:50`,
        totalSetupDur: "1:30",
        colorSetupDur: "-",
        widthSetupDur: "1:30",
        dueDateViolations: 0
      },
      {
        isOnTime: <img src={happy} width={25} height={25} alt="yes"/>,
        orderNr: 1002,
        width: 18,
        color: <mark style={{color: "#9C33FF", backgroundColor: "transparent", fontWeight: 800}}>Violett</mark>,
        moveUp: "",
        dueDate: dateMath.add(new Date(), 3, "day").toLocaleDateString(),
        endTime: `${dateMath.add(new Date(), 2, "day").toLocaleDateString()} 5:20`,
        totalSetupDur: "0:30",
        colorSetupDur: "-",
        widthSetupDur: "0:30",
        dueDateViolations: 0
      },
    {
      isOnTime: <img src={happy} width={25} height={25} alt="yes"/>,
      orderNr: 1001,
      width: 14,
      color: <mark style={{color: "green", backgroundColor: "transparent", fontWeight: 800}}>Grün</mark>,
      moveUp: "",
      dueDate: dateMath.add(new Date(), 2, "day").toLocaleDateString(),
      endTime: `${dateMath.add(new Date(), 2, "day").toLocaleDateString()} 18:00`,
      totalSetupDur: "4:40",
      colorSetupDur: "4:00",
      widthSetupDur: "0:40",
      dueDateViolations: 0
    },
    {
        isOnTime: <img src={happy} width={25} height={25} alt="yes"/>,
        orderNr: 1007,
        width: 17,
        color: <mark style={{color: "green", backgroundColor: "transparent", fontWeight: 800}}>Grün</mark>,
        moveUp: "",
        dueDate: dateMath.add(new Date(), 4, "day").toLocaleDateString(),
        endTime: `${dateMath.add(new Date(), 3, "day").toLocaleDateString()} 2:30`,
        totalSetupDur: "0:30",
        colorSetupDur: "-",
        widthSetupDur: "0:30",
        dueDateViolations: 0
      },
      {
        isOnTime: <img src={happy} width={25} height={25} alt="yes"/>,
        orderNr: 1006,
        width: 34,
        color: <mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>Blau</mark>,
        moveUp: "",
        dueDate: dateMath.add(new Date(), 3, "day").toLocaleDateString(),
        endTime: `${dateMath.add(new Date(), 3, "day").toLocaleDateString()} 21:20`,
        totalSetupDur: "10:50",
        colorSetupDur: "8:00",
        widthSetupDur: "2:50",
        dueDateViolations: 0
      },
    {
      isOnTime: <img src={happy} width={25} height={25} alt="yes"/>,
      orderNr: 1003,
      width: 22,
      color: <mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>Blau</mark>,
      moveUp: "",
      dueDate: dateMath.add(new Date(), 4, "day").toLocaleDateString(),
      endTime: `${dateMath.add(new Date(), 4, "day").toLocaleDateString()} 7:20`,
      totalSetupDur: "2:00",
      colorSetupDur: "-",
      widthSetupDur: "2:00",
      dueDateViolations: 0
    },
  ]

function OptimalOrder (props) {

  let score = 1400;
  let dueDateViolations = 0;
  let isMobile = props.isMobile;

  const { t } = useTranslation();

  return (
    <div className="table-responsive dnd-wrapper">
      <KPIs score={score} dueDateViolations={dueDateViolations} />
      {isMobile ?
        ordersExample.map((order) => (
        <div className="card" key={order.orderNr}>
          <div className="card-body p-1">
            <ul className="list-group list-group-horizontal row gy-1">
              <li className="list-group-item p-0 value col">
                <img src={orderNr} width={20} height={20} alt="orderNr" />
                <p>{order.orderNr}</p>
              </li>
              <li className="list-group-item p-0 value col" >
                <img src={width} width={20} height={20} alt="width" />
                <p>{order.width}</p>
              </li>
              <li className="list-group-item p-0 value col" >
                <img src={color} width={20} height={20} alt="color" />
                {order.color.props.children === "Blau" ? <p><mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>{t("blue")}</mark></p> 
                  : order.color.props.children === "Violett" ? <p><mark style={{color: "#9C33FF", backgroundColor: "transparent", fontWeight: 800}}>{t("violet")}</mark></p> 
                  : <p><mark style={{color: "green", backgroundColor: "transparent", fontWeight: 800}}>{t("green")}</mark></p>}
              </li>
              <li className="list-group-item p-0 value col">
                <img src={dueDate} width={20} height={20} alt="dueDate" />
                <p>{order.dueDate}</p>
              </li>
            </ul>
            <ul className="list-group list-group-horizontal row gy-1">
              <li className="list-group-item p-0 value col">
                <img src={width} width={20} height={20} alt="width" />
                <img src={setupTime} width={20} height={20} alt="setupTime" />
                <p>{order.widthSetupDur}</p>
              </li>
              <li className="list-group-item p-0 value col">
                <img src={color} width={20} height={20} alt="color" />
                <img src={setupTime} width={20} height={20} alt="setupTime" />
                <p>{order.colorSetupDur}</p>
              </li>
              <li className="list-group-item p-0 value col">
                <img src={sigma} width={15} height={15} alt="sigma" />
                <img src={setupTime} width={20} height={20} alt="setupTime" />
                <p>{order.totalSetupDur}</p>
              </li>
            </ul>
            <ul className="list-group list-group-horizontal row gy-1">
              <li className="list-group-item p-0 value col">
                <p>{order.moveUp}</p>
              </li>
              <li className="list-group-item p-0 value col">
                <img src={endTime} width={20} height={20} alt="endTime" />
                <p>{order.endTime}</p>
              </li>
              <li className="list-group-item p-0 value col">
                <p>{order.isOnTime}</p>
              </li>
            </ul>
          </div>
        </div>
        ))
        :
        <table className="table table-sm table-hover table-bordered table-dnd">
          <thead className="table-light">
            <tr>
              <th>{t("isOnTime")}</th>
              <th>{t("orderNr")}</th>
              <th>{t("width")}</th>
              <th>{t("color")}</th>
              <th>{t("moveUp")}</th>
              <th>{t("dueDate")}</th> 
              <th>{t("endTime")}</th>
              <th>{t("totalSetupDur")}</th>
              <th>{t("colorSetupDur")}</th>
              <th>{t("widthSetupDur")}</th>
            </tr>
          </thead>
          <tbody>
            {ordersExample.map((order) => (
              <tr key={order.orderNr}>
                <td>{order.isOnTime}</td>
                <td>{order.orderNr}</td>
                <td>{order.width}</td>
                {order.color.props.children === "Blau" ? <td><mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>{t("blue")}</mark></td> 
                  : order.color.props.children === "Violett" ? <td><mark style={{color: "#9C33FF", backgroundColor: "transparent", fontWeight: 800}}>{t("violet")}</mark></td> 
                  : <td><mark style={{color: "green", backgroundColor: "transparent", fontWeight: 800}}>{t("green")}</mark></td>}
                <td>{order.moveUp}</td>
                <td>{order.dueDate}</td>
                <td>{order.endTime}</td>
                <td>{order.totalSetupDur}</td>
                <td>{order.colorSetupDur}</td>
                <td>{order.widthSetupDur}</td>
              </tr>
            ))}
          </tbody>
        </table>
      }
    </div>
  );
}

export default OptimalOrder;